import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VerticalCard from "../components/VerticalCard";
import SummaryApi from "../common";
import { motion, AnimatePresence } from "framer-motion";
import { FaFilter } from "react-icons/fa";

const CategoryProduct = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const query = new URLSearchParams(location.search);
useEffect(() => {
  const query = new URLSearchParams(location.search);
  setFilters(prev => ({
    ...prev,
    category: query.get("category") || ""
  }));
}, [location.search]);
  // 🔥 FILTER STATE
  const [filters, setFilters] = useState({
    brand: query.get("brand") || "",
    category: query.get("category") || "",
    processor: query.get("processor") || "",
    generation: query.get("generation") || "",
    ram: query.get("ram") || "",
    storage: query.get("storage") || "",
    screenSize: query.get("screenSize") || "",
    price: query.get("price") || 50000,
  });

  const [sortBy, setSortBy] = useState("");

  const getPrice = (item) =>
    Number(item?.variants?.[0]?.price || 0);

  // 🔥 FETCH DATA
  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await fetch(SummaryApi.filterProduct.url, {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(filters),
      });

      const result = await res.json();
      setData(result?.data || []);
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  // 🔥 UPDATE FILTER
  const handleFilterChange = (key, value) => {
    const updated = {
      ...filters,
      [key]: filters[key] === value ? "" : value,
    };

    setFilters(updated);
    navigate(`/product-category?${new URLSearchParams(updated)}`);
  };

  // 🔥 CLEAR
  const clearFilters = () => {
    const reset = {
      brand: "",
      category: "",
      processor: "",
      generation: "",
      ram: "",
      storage: "",
      screenSize: "",
      price: 50000,
    };

    setFilters(reset);
    navigate("/product-category");
  };

  // 🔥 SORT
  const handleSort = (value) => {
    setSortBy(value);

    let sorted = [...data];

    if (value === "asc")
      sorted.sort((a, b) => getPrice(a) - getPrice(b));
    if (value === "dsc")
      sorted.sort((a, b) => getPrice(b) - getPrice(a));

    setData(sorted);
  };

  // 🔥 FILTER DATA
  const brands = ["Dell","HP","Lenovo","Asus","Acer","Apple"];
// const categories = ["Gaming Laptop","Business Laptop","2in1","Ultrabook","Desktop"];
//     enum: ["gaming", "business", "2in1", "ultrabook", "desktop"]
const categories = ["gaming", "business", "2in1", "ultrabook", "desktop"]
const screenSizes = ["13.3", "14", "15.6", "16"];
  const processors = ["i3","i5","i7","i9","Ryzen5","Ryzen7"];
  const generations = ["5th","6th","7th","8th","9th","10th","11th","12th"];
  const ramList = ["4GB","8GB","16GB","32GB"];
  const storageList = ["256GB SSD","512GB SSD","1TB SSD"];

  return (
    <div className="min-h-screen relative overflow-hidden bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black">

      {/* 🔥 BACKGROUND GLOW */}
      <div className="absolute w-[400px] h-[400px] bg-purple-500 blur-[120px] opacity-20 top-[-100px] left-[-100px]"></div>
      <div className="absolute w-[400px] h-[400px] bg-blue-500 blur-[120px] opacity-20 bottom-[-100px] right-[-100px]"></div>

      <div className="relative max-w-8xl mx-auto px-4 py-6">

        {/* 🔥 HEADER */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-white text-xl font-bold">
            Products ({data.length})
          </h2>

          <div className="flex gap-3">

            <select
              value={sortBy}
              onChange={(e) => handleSort(e.target.value)}
              className="bg-white/10 text-white px-3 py-2 rounded-xl border border-white/20"
            >
              <option value="">Sort</option>
              <option value="asc">Low → High</option>
              <option value="dsc">High → Low</option>
            </select>

            <button
              onClick={() => setShowFilter(true)}
              className="lg:hidden bg-white/20 text-white px-4 py-2 rounded-xl flex gap-2 items-center"
            >
              <FaFilter /> Filter
            </button>

          </div>
        </div>

        <div className="grid lg:grid-cols-[280px,1fr] gap-6">

          {/* 🔥 FILTER */}
          <AnimatePresence>
            {(showFilter || window.innerWidth >= 1024) && (
              <motion.div
                initial={{ x: -300 }}
                animate={{ x: 0 }}
                exit={{ x: -300 }}
                className="fixed lg:sticky top-0 left-0 w-[280px] h-full bg-white/10 backdrop-blur-xl border border-white/20 shadow-xl p-5 z-50 overflow-y-auto rounded-r-2xl"
              >

                <div className="flex justify-between mb-4">
                  <h3 className="text-white font-bold">Filters</h3>
                  <button onClick={() => setShowFilter(false)} className="lg:hidden text-white">✕</button>
                </div>

                <button onClick={clearFilters} className="text-red-400 text-sm mb-4 underline">
                  Clear All
                </button>

                <FilterSection title="Category" data={categories} filterKey="category" filters={filters} handle={handleFilterChange}/>
                <FilterSection title="Brand" data={brands} filterKey="brand" filters={filters} handle={handleFilterChange}/>
                <FilterSection title="Processor" data={processors} filterKey="processor" filters={filters} handle={handleFilterChange}/>
                <FilterSection title="Generation" data={generations} filterKey="generation" filters={filters} handle={handleFilterChange}/>
                <FilterSection title="RAM" data={ramList} filterKey="ram" filters={filters} handle={handleFilterChange}/>
                <FilterSection title="Storage" data={storageList} filterKey="storage" filters={filters} handle={handleFilterChange}/>

                {/* PRICE */}
                <div className="mb-5">
                  <h4 className="text-white text-sm mb-2">Price</h4>

                  <input
                    type="range"
                    min="0"
                    max="100000"
                    value={filters.price}
                    onChange={(e) =>
                      setFilters(prev => ({
                        ...prev,
                        price: e.target.value
                      }))
                    }
                    className="w-full accent-green-400"
                  />

                  <p className="text-gray-300 text-sm mt-1">
                    ₹0 - ₹{filters.price}
                  </p>
                </div>

              </motion.div>
            )}
          </AnimatePresence>

          {/* 🔥 PRODUCTS */}
          <div>

            {loading ? (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[...Array(8)].map((_, i) => (
                  <div key={i} className="h-60 bg-white/10 animate-pulse rounded-xl"></div>
                ))}
              </div>
            ) : data.length === 0 ? (
              <div className="text-center text-gray-400 py-20">
                No products found 😢
              </div>
            ) : (
              <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">

                {data.map((item) => (
                  <motion.div
                    key={item._id}
                    whileHover={{ y: -10, scale: 1.03 }}
                  >
                    <div className="bg-white/10 backdrop-blur-xl p-2 rounded-2xl border border-white/10">
                      <VerticalCard data={[item]} />
                    </div>
                  </motion.div>
                ))}

              </div>
            )}

          </div>

        </div>

      </div>
    </div>
  );
};

export default CategoryProduct;


// 🔥 FILTER COMPONENT
const FilterSection = ({ title, data, filterKey, filters, handle }) => {
  return (
    <div className="mb-5">
      <h4 className="text-white text-sm mb-2">{title}</h4>

      <div className="flex flex-wrap gap-2">
        {data.map((item) => (
          <button
            key={item}
            onClick={() => handle(filterKey, item)}
            className={`px-3 py-1 text-xs rounded-full transition backdrop-blur-md
            ${
              filters[filterKey] === item
                ? "bg-green-500 text-white scale-105 shadow"
                : "bg-white/90 text-gray-800 border border-white/70 hover:bg-white/20"
            }`}
          >
            {item}
          </button>
        ))}
      </div>
    </div>
  );
};